import IoTIcon from 'assets/img/PNG/category/IOT.png';
import CloudIcon from 'assets/img/PNG/category/CloudInstance.png';
import SaasIcon from 'assets/img/PNG/category/Saas.png';
import PremiseIcon from 'assets/img/PNG/category/Premise.png';
import OfficeIcon from 'assets/img/PNG/category/Office.png';
import IoMDIcon from 'assets/img/PNG/category/IoMD.png';
import DataIcon from 'assets/img/PNG/category/Datacenter.png';
import MobileIcon from 'assets/img/PNG/category/MobileDevice.png';
import AppIcon from 'assets/img/PNG/category/Application.png';
import ComputerIcon from 'assets/img/PNG/category/Computerlaptop.png';
import ThingIcon from 'assets/img/PNG/device.png';
import PasswordIcon from 'assets/img/PNG/password_icon.png';
import AddressIcon from 'assets/img/PNG/address.png';
import GatewayIcon from 'assets/img/PNG/gateway.png';
import UserIcon from 'assets/img/SVG/ecosystem-user.svg';
import GroupIcon from 'assets/img/SVG/group.svg';

import NewUser from 'Modals/NewUser';
import GroupDetail from 'Modals/GroupDetail';
import GroupForm from 'views/Objects/Groups/GroupForm';
import ThingForm from 'views/Objects/Things/ThingForm';
import ThingDetail from 'views/Objects/Things/ThingDetail';
import GatewayForm from 'views/Objects/Gateways/GatewayForm';
import GatewayDetail from 'views/Objects/Gateways/GatewayDetail';
import AddressForm from 'views/Objects/Addresses/AddressForm';
import AddressDetail from 'views/Objects/Addresses/AddressDetail';
import PublicAddressForm from 'views/Objects/AllocatedIPs/AddressForm';
import PublicAddressDetail from 'views/Objects/AllocatedIPs/AddressDetail';

import { LDAP_EXTERNAL_SYSTEM } from '../LDAPConfig';

export const OBJECT_ASSET_VALUES = Array.from(Array(101).keys()).map((n) => ({
  label: String(n),
  value: n,
}));

export const OBJECT_CATEGORIES = [
  { label: 'IoT', value: 'IoT', icon: IoTIcon },
  { label: 'Cloud Instance', value: 'Cloud Instance', icon: CloudIcon },
  { label: 'Saas', value: 'Saas', icon: SaasIcon },
  { label: 'Premise', value: 'Premise', icon: PremiseIcon },
  { label: 'IoMD', value: 'IoMD', icon: IoMDIcon },
  { label: 'Data Center', value: 'Data Center', icon: DataIcon },
  { label: 'Mobile Device', value: 'Mobile Device', icon: MobileIcon },
  { label: 'Application', value: 'Application', icon: AppIcon },
  { label: 'Computer / Laptop', value: 'Computer / Laptop', icon: ComputerIcon },
  { label: 'Building - OT', value: 'Building - OT', icon: OfficeIcon },
  { label: 'Building - ICS', value: 'Building - ICS', icon: OfficeIcon },
  { label: 'Building - SCADA', value: 'Building - SCADA', icon: OfficeIcon },
  { label: 'Building - BMS', value: 'Building - BMS', icon: OfficeIcon },
  { label: 'Building - Metering', value: 'Building - Metering', icon: OfficeIcon },
  { label: 'Building - Lighting', value: 'Building - Lighting', icon: OfficeIcon },
  { label: 'Building - Life Safety', value: 'Building - Life Safety', icon: OfficeIcon },
  { label: 'Building - Physical Access', value: 'Building - Physical Access', icon: OfficeIcon },
  { label: 'Building - Surveillance', value: 'Building - Surveillance', icon: OfficeIcon },
  { label: 'Building - Elevator Control', value: 'Building - Elevator Control', icon: OfficeIcon },
];

export const OBJECT_TYPES = {
  ADDRESS: 'address',
  GATEWAY: 'gateway',
  PUBLIC_ADDRESS: 'publicAddress',
  THING: 'thing',
  USER: 'user',
  SERVER: 'server',
  GROUPS: 'group',
  MFA: 'mfa',
};

export const OBJECT_MENU_CONFIG = [
  {
    type: 'address',
    url: 'addresses',
    title: 'Addresses',
    label: 'Address',
    icon: AddressIcon,
    iconStyle: { width: 14 },
  },
  {
    type: 'publicAddress',
    url: 'publicAddresses',
    title: 'Allocated IPs',
    label: 'Allocated IP',
    icon: AddressIcon,
    iconStyle: { width: 14 },
  },
  {
    type: 'gateway',
    url: 'gateways',
    title: 'Gateways',
    label: 'Gateway',
    icon: GatewayIcon,
    iconStyle: { width: 20 },
  },
  {
    type: 'group',
    url: 'groups',
    title: 'Profile Groups',
    label: 'Profile Group',
    icon: GroupIcon,
    iconStyle: { width: 16 },
    objIdentity: true,
  },
  {
    type: 'user',
    url: 'users',
    title: 'Users',
    label: 'User',
    icon: UserIcon,
    iconStyle: { width: 14 },
    objIdentity: true,
  },
  {
    type: 'thing',
    url: 'things',
    title: 'Things',
    label: 'Thing',
    icon: ThingIcon,
    iconStyle: { width: 12 },
    objIdentity: true,
  },
  {
    type: 'server',
    url: 'servers',
    title: 'Providers',
    label: 'Server',
    icon: ThingIcon,
    iconStyle: { width: 14 },
    objIdentity: true,
  },
  {
    type: 'mfa',
    url: 'mfa',
    title: 'Multi-Factor Auth',
    label: 'MFA',
    icon: PasswordIcon,
    iconStyle: { width: 14 },
    objIdentity: true,
  },
];

export const OBJECT_TABLE_FIELDS = {
  object: [
    { name: 'OBJECT', center: false },
    { name: 'DETAILS', center: false },
    { name: 'REGION', center: false },
    { name: 'STATUS', center: false },
  ],
  address: [
    { name: 'OBJECT', center: false },
    { name: 'ADDRESS', center: false },
    { name: 'DETAILS', center: false },
  ],
  gateway: [
    { name: 'OBJECT', center: false },
    { name: 'NETWORKS', center: false },
    { name: 'REGION', center: false },
    { name: 'MODE', center: false },
    { name: 'DETAILS', center: false },
  ],
  thing: [
    { name: 'OBJECT', center: false },
    { name: 'PROFILE GROUP', center: false },
    { name: 'REGION', center: false },
    { name: 'DETAILS', center: false },
  ],
  group: [
    { name: 'OBJECT', center: false },
    { name: 'DETAILS', center: false },
  ],
  user: [
    { text: 'First name', dataField: 'firstName' },
    { text: 'Last name', dataField: 'lastName' },
    { text: 'Username', dataField: 'login' },
    { text: 'Role', dataField: 'role' },
    { text: 'Profile Group', dataField: 'profileGroup' },
    { text: 'E-mail', dataField: 'email' },
    { text: 'Source', dataField: 'source' },
    { text: 'Invitation', dataField: 'status' },
    { text: 'MFA Status', dataField: 'activationStatus' },
  ],
};

export const OBJECT_TYPE_OPTIONS = [
  { label: 'Thing', value: 'thing' },
  { label: 'Address', value: 'address' },
  { label: 'IPSec', value: 'gateway' },
];

export const OBJECT_TYPES_CONFIG = [
  {
    name: 'thing',
    urlType: 'devices',
    title: 'Create New Thing',
    createComponent: ThingForm,
    detailComponent: ThingDetail,
  },
  {
    name: 'gateway',
    urlType: 'gateways',
    title: 'Create New Gateway',
    createComponent: GatewayForm,
    detailComponent: GatewayDetail,
  },
  {
    name: 'address',
    urlType: 'addresses',
    title: 'Create New Address',
    createComponent: AddressForm,
    detailComponent: AddressDetail,
  },
  {
    name: 'publicAddress',
    urlType: 'publicAddresses',
    title: 'Create New Allocated IP',
    createComponent: PublicAddressForm,
    detailComponent: PublicAddressDetail,
  },
  {
    name: 'group',
    urlType: 'groups',
    title: 'Create New Profile Group',
    createComponent: GroupForm,
    detailComponent: GroupDetail,
  },
  {
    name: 'user',
    urlType: 'users',
    title: 'Create New Users',
    createComponent: NewUser,
  },
  {
    name: 'server',
    urlType: 'idp/ldap',
    title: 'Create New Server',
  },
];

export const OBJECT_STATUS_OPTIONS = [
  { value: true, label: 'Enabled', disabled: true },
  /* Hide until API is ready 
		{ value: false, label: 'Disabled', disabled:true }
	*/
];

export const LDAP_CONN_TYPE = {
  THROUGH_GATEWAY: '1',
  THROUGH_INTERNET: '2',
};

export const LDAP_CONN_TYPE_OPTIONS = [
  {
    summaryLabel: 'Connected through Gateway',
    label: 'Server is connected to this ecosystem through a Gateway',
    value: LDAP_CONN_TYPE.THROUGH_GATEWAY,
  },
  {
    summaryLabel: 'Available publicly over the internet',
    label: 'Server is available publicly over the internet',
    value: LDAP_CONN_TYPE.THROUGH_INTERNET,
  },
];
export const LDAP_URL_SCHEMES = {
  LDAP: 'ldap://',
  LDAPS: 'ldaps://',
};
export const LDAP_URL_SCHEMES_OPTIONS = [
  { value: LDAP_URL_SCHEMES.LDAP, label: LDAP_URL_SCHEMES.LDAP },
  { value: LDAP_URL_SCHEMES.LDAPS, label: LDAP_URL_SCHEMES.LDAPS },
];
export const LDAP_USER_SCHEMA_OPTIONS = [
  { value: 'cn', label: 'cn' },
  { value: 'uid', label: 'uid' },
  { value: 'userPrincipalName', label: 'userPrincipalName' },
  { value: 'sAMAccountName', label: 'sAMAccountName' },
];
export const FILE_IMPORT = {
  FILE_CONTENT: 'content',
  FILE_UPLOAD: 'upload',
};
export const FILE_IMPORT_OPTIONS = [
  { value: FILE_IMPORT.FILE_CONTENT, label: 'Paste file Content' },
  { value: FILE_IMPORT.FILE_UPLOAD, label: 'File Upload' },
];
export const USER_ADD_OPTIONS = [
  { value: '1', label: 'Add Manually' },
  { value: '2', label: 'Import from Comma Separated Value(csv)' },
  // { value: '3', label: 'Connect to existing identity provider (LDAP, AD)' }
];

export const USER_MODAL_TYPE = {
  CREATE_USER: 'CREATE_USER',
  IMPORT_USER: 'IMPORT_USER',
  LDAP_CONF: 'LDAP_CONF',
};

export const CREATE_USER_MODAL_TITLE_MAPPING = {
  CREATE_USER: 'Add Users',
  IMPORT_USER: 'Import Users',
  LDAP_CONF: 'Identity Provider',
  [LDAP_EXTERNAL_SYSTEM.GENERIC]: 'Identity Provider: Generic LDAP',
  [LDAP_EXTERNAL_SYSTEM.AZURE_AD]: 'Identity Provider: Azure AD',
  [LDAP_EXTERNAL_SYSTEM.WINDOWS_ON_PREM]: 'Identity Provider: Windows On-Premise',
  [LDAP_EXTERNAL_SYSTEM.OKTA]: 'Identity Provider: OKTA',
};
